import { Send } from "lucide-react";
import { useState } from "react";

import { RecycleAgents } from "@/components/recycle/RecycleAgents";

import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";

export const RecycleSend = ({ agents, tagOptions, count, lists, sending, onSend, cfg, setCfg, recycledNote = true, showAgents = true }) => {
  const [confirm, setConfirm] = useState(false);
  const [tagInput, setTagInput] = useState("");
  const addTag = (t) => { const v = t.trim(); if (v) setCfg((c) => (c.tags.includes(v) ? c : { ...c, tags: [...c.tags, v] })); setTagInput(""); };
  const assigned = agents.filter((a) => cfg.agents.includes(a.id)).map((a) => a.name);
  const n = cfg.agents.length;
  const perAgent = n ? Math.ceil(count / n) : 0;
  lists = n ? n * Math.max(1, Math.ceil(perAgent / 4999)) : lists;
  return (
    <div className="rc-grid" data-testid="recycle-send">
      <div className="rc-field">
        <span>Titre des listes</span>
        <input value={cfg.title} onChange={(e) => setCfg({ ...cfg, title: e.target.value })} data-testid="recycle-title" />
        <small>Ex. « {cfg.title || "Recyclage"} - {new Date().toISOString().slice(0, 10)}{lists > 1 ? " - 001" : ""} »</small>
      </div>
      <div className="rc-field">
        <span>Tags</span>
        <div className="rc-taginput" data-testid="recycle-tag-box">
          {cfg.tags.map((t) => <span key={t} className="rc-pill" data-testid={`recycle-tag-${t}`}>{t}<button type="button" aria-label={`Retirer ${t}`} onClick={() => setCfg({ ...cfg, tags: cfg.tags.filter((x) => x !== t) })}>×</button></span>)}
          <input list="recycle-tag-options" value={tagInput} placeholder={cfg.tags.length ? "Autre tag…" : "Tapez un tag puis Entrée ou virgule"}
            onChange={(e) => { const v = e.target.value; if (v.includes(",")) { v.split(",").forEach((x) => x.trim() && addTag(x)); setTagInput(""); } else setTagInput(v); }}
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addTag(tagInput); } else if (e.key === "Backspace" && !tagInput && cfg.tags.length) setCfg({ ...cfg, tags: cfg.tags.slice(0, -1) }); }}
            onBlur={() => tagInput.trim() && addTag(tagInput)} data-testid="recycle-tag-input" />
          <datalist id="recycle-tag-options">{tagOptions.map((t) => <option key={t} value={t} />)}</datalist>
        </div>
      </div>
      <div className="rc-field rc-wide">
        <span>Description / consigne d'appel</span>
        <textarea rows={2} value={cfg.description} onChange={(e) => setCfg({ ...cfg, description: e.target.value })} data-testid="recycle-description" />
      </div>
      {showAgents && <RecycleAgents agents={agents} count={count} cfg={cfg} setCfg={setCfg} />}
      <div className="rc-field rc-wide">
        <button type="button" className="primary-button" disabled={!count || sending} onClick={() => setConfirm(true)} data-testid="recycle-send-btn">
          <Send size={15} /> {sending ? "Envoi en cours…" : `Envoyer dans noCRM (${count.toLocaleString("fr-FR")} lignes, ${lists} liste${lists > 1 ? "s" : ""})`}
        </button>
      </div>
      <AlertDialog open={confirm} onOpenChange={setConfirm}>
        <AlertDialogContent data-testid="recycle-confirm">
          <AlertDialogHeader>
            <AlertDialogTitle>Créer {lists} liste{lists > 1 ? "s" : ""} de prospection dans noCRM ?</AlertDialogTitle>
            <AlertDialogDescription>
              {count.toLocaleString("fr-FR")} prospects seront envoyés{assigned.length ? `, assignés à ${assigned.join(", ")}` : " sans agent assigné"}{cfg.tags.length ? `, tags : ${cfg.tags.join(", ")}` : ""}.{recycledNote ? " Ces numéros seront marqués comme recyclés." : ""} Utilise {lists} appel{lists > 1 ? "s" : ""} sur le quota noCRM.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="recycle-confirm-cancel">Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={onSend} data-testid="recycle-confirm-ok">Envoyer</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
};
